export function panelUpgrade(cimDoc) {
    /* eslint-disable no-param-reassign */
    if (cimDoc.document.surfaces) {
        cimDoc.document.panels = cimDoc.document.surfaces;
        delete cimDoc.document.surfaces;
    }
    /* eslint-enable no-param-reassign */
    return cimDoc;
}
//# sourceMappingURL=panelUpgrade.js.map